export const PAGE_INFO_MODULE = 'PAGE_INFO';

export const PageInfoActions = {
    SET_CURRENT_PAGE_INFO: 'SET_CURRENT_PAGE_INFO',
    RESET_CURRENT_PAGE_INFO: 'RESET_CURRENT_PAGE_INFO',
};
